import { Locale } from '@synergy/models';
import { ReactElement } from 'react';

export interface PaloLanguageSwitchProps {
    /**
     * Runs before the language changes; return false to keep the current one,
     * e.g. while a screen asks whether to discard unsaved input.
     */
    onBeforeSwitch?: (locale: Locale) => boolean;
}

/**
 * Language switch for PALO headers — drawn nowhere for the time being.
 *
 * Everything here is meant to be read and written in German only, so the
 * switch is out of every header. It is the display that is gone, not the
 * translations: the records keep their other language versions, the
 * configuration still lists four locales, and what becomes of them is a
 * question of its own. Until that is settled this renders nothing, so the
 * screens around it keep their shape and bringing it back is one line.
 */
export const PaloLanguageSwitch = (_props: PaloLanguageSwitchProps = {}): ReactElement | null => null;
